"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replayHistoryOperation = void 0;
exports.replayHistoryOperation = {
    method: 'POST',
    name: 'replayHistory',
    id: 'ReplayHistory',
    groupName: 'history',
    urlPathPattern: '/history/replay/{streamId}/{id}',
    urlPathParamNames: ['streamId', 'id'],
    bodyParamNames: [],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        streamId: request.streamId,
        id: request.id,
    };
}
function getRequestBody() {
    return {};
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        streamId: request.streamId,
        id: request.id,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        streamId: jsonRequest.streamId,
        id: jsonRequest.id,
    };
}
//# sourceMappingURL=replayHistoryOperation.js.map